import seedrandom from "seedrandom";
import { arrayToString } from "./utils";
export function generateSeed(): string {

  const state = seedrandom(undefined, { state: true }).state() as { S: number[] };
  return arrayToString(state['S']);
  // const seed: string = state['S'].map(c => String.fromCharCode(c)).join('')
  // return seed;
}